module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social"
  }, [(_vm.website) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.website,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "laptop",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.twitter) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.twitter,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.github) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.github,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "github",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.instagram) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.instagram,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.linkedin) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.linkedin,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.googlePlus) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.googlePlus,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "google-plus",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.facebook) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.facebook,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook",
      "scale": _vm.scale
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b4d56ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialIcons.vue
// module id = 909
// module chunks = 1